import {Component} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {GenericChartComponent} from '../generic-chart/generic-chart.component';
import {FinanceDashboardChartType} from '../../enum/FinanceDashboardChartType';
import {ExternalTravelTypePieChartColorOptionsArray} from '../../constants/finance-dashboard-chart-options';

@Component({
  selector: 'app-gross-fare-by-external-travel-type',
  templateUrl: './gross-fare-by-external-travel-type.component.html',
  standalone: false
})

@AutoUnsubscribe()
export class GrossFareByExternalTravelTypeComponent extends GenericChartComponent {
  constructor() {
    super();
    this.chartConfiguration = {
      title: 'Gross Fare by External Travel Type',
      chartType: FinanceDashboardChartType.Pie,
      backGroundColor: ExternalTravelTypePieChartColorOptionsArray,
      borderColor: ExternalTravelTypePieChartColorOptionsArray,
    };
  }
}
